<template>
  <div class="unsubscribe-page" v-if="!isLoading">
    <div
        class="d-flex flex-column justify-content-center text-center primary-bg-colour primary-text unsubscribe-header">
      <img @click="backButtonClicked" :src="require(`../../brand/${brandConfig.brand}/assets/left-keyboard-arrow.png`)"
           class="go-back-key">
      {{ translationsFormatter('unsubscribe_header') }}
    </div>
    <div
        class="d-flex flex-column justify-content-center text-center p-4 secondary-bg-colour primary-text subscription-status-text">
      {{ translationsFormatter('unsubscribe_status', [brandConfig.brand]) }}
    </div>
    <div class="d-flex align-items-center justify-content-center circle-container pt-5 pb-4">
      <div class="d-flex flex-column justify-content-center primary-bg-colour primary-text exclamation-mark-circle">
        !
      </div>
    </div>
    <div class="d-flex flex-column text-center p-4 pt-5 pb-5 unsubscribe_confirm_unsubscription_text">
      {{ translationsFormatter('unsubscribe_confirm_unsubscription', [brandConfig.brand]) }}
    </div>
    <div class="d-flex flex-column align-items-center justify-content-center">
      <button @click="confirmButtonClicked()" class="mt-4 col-10 primary-bg-colour primary-text save-button">
        {{ translationsFormatter('unsubscribe_confirm_button') }}
      </button>
      <button @click="backButtonClicked" class="mt-1 mb-2 col-5 secondary-bg-colour primary-text back-button">
        {{ translationsFormatter('unsubscribe_back_button') }}
      </button>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import UserDataService from "@/services/userDataService";
import getServiceId from "@/functions/getServiceId";
import {environmentConfig} from "@/config/enviromentConfig";
import TelkomService from "@/services/telkomService";
import SafaricomService from "@/services/safaricomService";

export default {
  name: "Cancel Package",
  data() {
    return {}
  },
  beforeMount() {
    this.setIsLoading(false);
  },
  computed: {
    ...mapState(['isLoading', 'brandConfig', 'user'])
  },
  methods: {
    ...mapMutations(['setIsLoading']),
    backButtonClicked() {
      this.$router.push('/settings');
    },
    async confirmButtonClicked() {
      const serviceId = getServiceId();
      if (this.brandConfig.brand === 'tlk-za-en') await TelkomService.unSubscribe(this.user.msisdn, this.brandConfig.productId);
      if (this.brandConfig.brand === 'saf-ke-en') await SafaricomService.unsubscribe(12 ,this.user.channelId, this.user.msisdn, this.user.offerCode);
      await UserDataService.unsubscribe(`${this.user.msisdn}`, this.user.token, `${this.brandConfig.revenuePartnerId}`, serviceId, this.user.scheme)
      this.handleUnsubRouting()
    },
    handleUnsubRouting() {
      const isBrandVcZaEn = this.brandConfig.brand === 'vc-za-en';
      const brandIsTelkom = this.brandConfig.brand === 'tlk-za-en';
      const brandIsSafariCom = this.brandConfig.brand === 'saf-ke-en';
      if (isBrandVcZaEn) return  window.open(`${environmentConfig.entryPortalHost}/login`, '_self');
      if (brandIsTelkom) return window.open('https://sdp-p-vas-payment.telkom.co.za/300000092', '_self');
      if (brandIsSafariCom) return window.open(`https://ke-mplay.fantasyfootball.one`, '_self');
      else this.$router.push('/login');
    },
  }
}
</script>

<style scoped>
.unsubscribe-page {
  background-color: #e8e8e8;
  overflow-y: scroll;
  padding-bottom: 20px;
}

.unsubscribe-page::-webkit-scrollbar {
  display: none;
}

.unsubscribe-header {
  position: relative;
  font-weight: 600;
  font-size: 18px;
  height: 45px;
}

.go-back-key {
  position: absolute;
  height: 20px;
  left: 27px;
  top: 13px;
}

.subscription-status-text {
  height: 70px;
  border-radius: 0 0 20px 20px;
  font-size: 14px;
  font-weight: 500;
}

.exclamation-mark-circle {
  position: absolute;
  width: 115px;
  height: 115px;
  border-radius: 50%;
  font-weight: 700;
  font-size: 80px;
  padding-bottom: 10px;
  padding-left: 44px;
}

.circle-container {
  height: 40%;
  position: relative;
  margin-top: 32px;
  margin-bottom: 32px;
}

.unsubscribe_confirm_unsubscription_text {
  font-weight: 700;
}

.save-button {
  height: 45px;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
}

.back-button {
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  height: 32px;
  border: 0;
}


</style>
